import { Button } from "@/modules/common/components/button";
import { Modal } from "@/modules/common/components/modal";

interface Props {
  open: boolean;
  handleClose: () => void;
  handleAction: () => void;
}

const SubscribeToStockModal = ({ open, handleClose, handleAction }: Props) => {
  return (
    <Modal
      isOpen={open}
      close={handleClose}
      title="Suscribirse a este producto."
      className="bg-cream"
    >
      <p>
        ¡Te enviaremos una notificación al correo apenas este producto vuelva a
        estar disponible!
      </p>

      <div className="mt-4 flex justify-end gap-2">
        <Button onClick={handleAction}>Aceptar</Button>
        <Button variant="ghost" onClick={handleClose}>
          Cancelar
        </Button>
      </div>
    </Modal>
  );
};

export default SubscribeToStockModal;
